import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant"];
import React from "react";
import Typography from "../../../../Typography";
import { BaseTextCell } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function TextCell(_ref) {
  var variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseTextCell, {
    children: /*#__PURE__*/_jsx(Typography, _extends({
      variant: "inherit",
      htmlTag: "div"
    }, props))
  });
}
TextCell.displayName = "TextCell";
export default TextCell;